export interface ArbCreateResultDto {
  ExternalArbId: string;
  Error: string;
}

// A created ARB's id is numeric (older gateways, legacy ARBs) or a GUID (Preczn).
const ARB_ID = /^(\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;
export const isArbId = (value: string | null | undefined): boolean => ARB_ID.test(value ?? '');
